export const mobileHeadingFontSizes = {
  /** 5.6rem = 56px */
  "6xl": "5.6rem",
  /** 4.8rem = 48px */
  "5xl": "4.8rem",
  /** 4rem = 40px */
  "4xl": "4rem",
  /** 3.2rem = 32px */
  "3xl": "3.2rem",
  /** 2.4rem = 24px */
  "2xl": "2.4rem",
  /** 2rem = 20px */
  xl: "2rem",
  /** 1.8rem = 18px */
  l: "1.8rem",
  /** 1.6rem = 16px */
  m: "1.6rem",
  /** 1.4rem = 14px */
  s: "1.4rem",
  /** 1.2rem = 12px */
  xs: "1.2rem",
  /** 1rem = 10px */
  "2xs": "1rem",
  /** 0.8rem = 8px */
  "3xs": "0.8rem",
};

export const desktopHeadingFontSizes = {
  /** 6.4rem = 64px */
  "6xl": "6.4rem",
  /** 5.6rem = 56px */
  "5xl": "5.6rem",
  /** 4.8rem = 48px */
  "4xl": "4.8rem",
  /** 4rem = 40px */
  "3xl": "4rem",
  /** 3.2rem = 32px */
  "2xl": "3.2rem",
  /** 2.4rem = 24px */
  xl: "2.4rem",
  /** 2rem = 20px */
  l: "2rem",
  /** 1.6rem = 16px */
  m: "1.6rem",
  /** 1.4rem = 14px */
  s: "1.4rem",
  /** 1.2rem = 12px */
  xs: "1.2rem",
  /** 1rem = 10px */
  "2xs": "1rem",
  /** 0.8rem = 8px */
  "3xs": "0.8rem",
};

export const bodyFontSizes = {
  /** 2rem = 20px */
  xl: "2rem",
  /** 1.6rem = 16px */
  l: "1.6rem",
  /** 1.4rem = 14px */
  m: "1.4rem",
  /** 1.2rem = 12px */
  s: "1.2rem",
  /** 1rem = 10px */
  xs: "1rem",
};
